import React, { useEffect, useState } from "react";
import { Plus, Eye } from "lucide-react";
import { toast } from "sonner";
import api, { taka } from "@/lib/api";
import { Modal, Field, inputCls, Th, Td, Empty, fmtDate } from "@/pages/admin/AdminUI";

export default function AdminSuppliers() {
  const [suppliers, setSuppliers] = useState([]);
  const [open, setOpen] = useState(false);
  const [view, setView] = useState(null);
  const [form, setForm] = useState({ name: "", mobile: "", address: "" });

  const load = () => api.get("/admin/suppliers").then((r) => setSuppliers(r.data));
  useEffect(() => { load(); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.name) return toast.error("নাম দিন");
    await api.post("/admin/suppliers", form); toast.success("যোগ হয়েছে"); setOpen(false); setForm({ name: "", mobile: "", address: "" }); load();
  };
  const openView = async (s) => { const { data } = await api.get(`/admin/suppliers/${s.id}`); setView(data); };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-2xl font-bold text-[#1E3A2B]">সরবরাহকারী</h1>
        <button onClick={() => setOpen(true)} className="bg-[#1E3A2B] text-white h-11 px-4 rounded-xl flex items-center gap-2 font-medium" data-testid="add-supplier-btn"><Plus size={18} /> নতুন সরবরাহকারী</button>
      </div>
      <div className="bg-white rounded-2xl border border-stone-200 overflow-x-auto">
        <table className="w-full min-w-[640px]">
          <thead className="bg-stone-50 border-b border-stone-200"><tr><Th>নাম</Th><Th>মোবাইল</Th><Th>মোট ক্রয়</Th><Th>পরিশোধিত</Th><Th>বাকি</Th><Th></Th></tr></thead>
          <tbody className="divide-y divide-stone-100">
            {suppliers.map((s) => (
              <tr key={s.id} data-testid={`supplier-row-${s.id}`}>
                <Td className="font-medium">{s.name}</Td><Td>{s.mobile}</Td>
                <Td>{taka(s.total_purchase)}</Td><Td>{taka(s.total_paid)}</Td>
                <Td className={s.due > 0 ? "text-red-600 font-semibold" : "text-emerald-700"}>{taka(s.due)}</Td>
                <Td><button onClick={() => openView(s)} className="p-2 text-blue-600" data-testid={`view-supplier-${s.id}`}><Eye size={16} /></button></Td>
              </tr>
            ))}
          </tbody>
        </table>
        {suppliers.length === 0 && <Empty />}
      </div>

      <Modal open={open} onClose={() => setOpen(false)} title="নতুন সরবরাহকারী">
        <div className="space-y-3">
          <Field label="নাম"><input className={inputCls} value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="sup-name" /></Field>
          <Field label="মোবাইল"><input className={inputCls} value={form.mobile} onChange={(e) => set("mobile", e.target.value)} data-testid="sup-mobile" /></Field>
          <Field label="ঠিকানা"><input className={inputCls} value={form.address} onChange={(e) => set("address", e.target.value)} /></Field>
          <button onClick={save} className="w-full bg-[#1E3A2B] text-white h-11 rounded-xl font-medium" data-testid="save-supplier-btn">সংরক্ষণ</button>
        </div>
      </Modal>

      <Modal open={!!view} onClose={() => setView(null)} title={view?.name} wide>
        {view && (
          <div className="space-y-3 text-sm">
            <div className="grid grid-cols-3 gap-2">
              <div className="bg-stone-50 rounded-lg p-2"><div className="text-xs text-stone-400">মোট ক্রয়</div><div className="font-semibold">{taka(view.total_purchase)}</div></div>
              <div className="bg-stone-50 rounded-lg p-2"><div className="text-xs text-stone-400">পরিশোধিত</div><div className="font-semibold">{taka(view.total_paid)}</div></div>
              <div className="bg-red-50 rounded-lg p-2"><div className="text-xs text-stone-400">বাকি</div><div className="font-semibold text-red-600">{taka(view.due)}</div></div>
            </div>
            <div className="font-semibold text-[#1E3A2B]">ক্রয় ইতিহাস</div>
            {view.purchases?.length ? view.purchases.map((p) => (
              <div key={p.id} className="flex justify-between border-b border-stone-100 py-1"><span>{p.purchase_no} • {p.quantity} কেজি</span><span className="font-medium">{taka(p.total)}</span></div>
            )) : <div className="text-stone-400">কোনো ক্রয় নেই</div>}
          </div>
        )}
      </Modal>
    </div>
  );
}
